export const getEditReasonFormConfig = () => [
  {
    type: 'textArea',
    name: 'edit_reason',
    label: 'Note to approvers',
    placeholder: 'Add a note for approvers (optional)',
    required: false,
    styleVersion: 'v2',
  },
];
